//请自行添加语言资源
const carrier = {
  carrierNo:'承运商编码',
  carrierShortName:'承运商简称',
  carrierName: '承运商全称',
  carrierTypeCode: '承运商类别编码',
  carrierTypeName:'承运商类别名称',
  contact:'联系人',
  tel:'联系电话',
  email: '电子邮箱',
  createTime:'创建时间',
  creator:'创建者',
  updateTime:'更新时间',
  updater:'更新者',
  msg:{
    recycleBoxNo: '请输入周转箱号起始数字',
    recycleBoxNoBegin: '请输入周转箱号结束数字',
    recycleBoxNoEnd: '请输入周转箱号',
    warehouseCode: '请选择仓库'
  }
};
export default carrier



// WEBPACK FOOTER //
// ./src/page/md/carrier/lang/carrier.zh.js